import { COLORS } from '@btime/constants'
import { __, compose, prop } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Grid } from '../../../../../../packages/kiti/components/structure/Grid'
import { SmallText } from '../../../../../../packages/kiti/components/presentation/Text'
import { Tags } from '../../../../../../components/presentation/Tag'
import { truncate } from '../../../../../../utils/helpers/string'
import { useChecklistFormActions } from '../../../_form/ChecklistFormHandler'
import Icon from '../../../../../../packages/kiti/components/shapes/Icon'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'
import { usePlaces } from '../../../_load/PlacesLoader'

const useConditionsLabel = (question, displayConditions) => {
  const { t } = useTranslation()
  const places = usePlaces()

  // TODO: Consider all conditions
  const firstCondition = displayConditions?.[0] || {}
  const questionType = question.questionType?.name
  const labels = question.data?.labels || {}

  if (questionType === 'checkbox') return [!!firstCondition.value ? labels.true || t('yes') : labels.false || t('no')]

  if (['select', 'multiple'].includes(questionType)) {
    return (firstCondition.value || []).map(compose(truncate(__, 20), prop('name')))
  }

  if (['btwn', 'nbtwn'].includes(firstCondition.operator)) {
    return [`${t('conditions.operators.' + firstCondition.operator)} ${firstCondition.value?.join(' e ')}`]
  }

  if (questionType === 'place') {
    const conditionsIds = firstCondition.value?.flatMap(item => item)
    return places.filter(place => conditionsIds.includes(place.id)).map(condition => condition.name)
  }

  return [`${t('conditions.operators.' + firstCondition.operator)} ${firstCondition.value}`]
}

const getConditionsTagColor = (question, displayConditions) => {
  // TODO: Consider all conditions
  const firstCondition = displayConditions?.[0] || {}
  if (question.questionType?.name !== 'checkbox') return COLORS.dark3
  return firstCondition.value ? COLORS.green : COLORS.red
}

const ConditionsLabel = ({ question, displayConditions, toggle, open, index }) => {
  const { t } = useTranslation('editChecklist')
  const { openConditionsModal, selectQuestion, removeChildConditionToSelectedQuestion } = useChecklistFormActions()
  const conditionsLabels = useConditionsLabel(question, displayConditions)
  const conditionsColor = getConditionsTagColor(question, displayConditions)

  const canManageConditions = question.questionType?.name !== 'checkbox'

  return (
    <Grid align="center">
      <Icon name={open ? 'BsCaretDownSquare' : 'BsCaretRightSquare'} color="dark3" onClick={toggle} />
      <Separator weight={2} vertical />
      <SmallText>{t('ifAnswerIs')}</SmallText>
      <Separator weight={2} vertical />
      <Tags circle color={conditionsColor} values={conditionsLabels} />

      {canManageConditions && (
        <Grid align="center">
          <Icon
            name="BsPencil"
            size={0.8}
            color="dark2"
            onClick={() => {
              selectQuestion(question.reference)
              openConditionsModal(index)
            }}
          />
          <Separator weigh={0.2} vertical />
          <Icon
            name="BsTrash"
            size={0.8}
            color="red"
            onClick={() => {
              selectQuestion(question.reference)
              removeChildConditionToSelectedQuestion(index)
            }}
          />
        </Grid>
      )}
    </Grid>
  )
}

export default ConditionsLabel
